import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import Properties360Service from '@/services/services/properties360.service';
import registerWeather from './weather';
import registerServiceLocation from './service_location';
import registerContacts from './contacts';
import registerMaintenancePlan from './maintenance_plan';
import registerWarrentyInventory from './warrenty_inventory';
import registerTechnicalInventories from './technical_inventories';

export default (store) => {
  store.registerModule(
    'properties_360',
    new BaseModule({
      serviceAPI: Properties360Service,
    })
  );

  const basePlugin = new BaseModulePlugins({
    paramId: 'propertyId',
    module: 'properties_360',
    store,
  });

  basePlugin.setCurrentLoading();
  basePlugin.onInit(() => {
    basePlugin.loadCurrentOnRouteParamsChange();
    basePlugin.onActiveRequestChange((request) => {
      store.dispatch(`properties_360/initCurrent`, request.property_id);
    });
    store.subscribeAction((action) => {
      if (action.type === 'sensors/properties/addCurrent') {
        store.dispatch('properties_360/initCurrent', action.payload.id);
      }
    });
  });

  registerWeather(store);
  registerServiceLocation(store);
  registerContacts(store);
  registerMaintenancePlan(store);
  registerWarrentyInventory(store);
  registerTechnicalInventories(store);
};
